<template>
    <div class="container">
<!-- <h2>Tipo de Equipos</h2>
<v-divider></v-divider> -->
        
            <v-card>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">ADMINISTRAR MAXISACOS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
            </v-card>
            
            <!-- <data-table class="mt-5" @editar="editar($event)" @enviar_jumbo_a_reproceso="enviar_a_reproceso($event)" @restablecer_jumbo="restablecer_jumbo($event)"></data-table> -->

            <!-- <modal @peticionrealizada="cargarDatos"></modal> -->

            <!-- <modal-jumbo-configurable></modal-jumbo-configurable> -->
            <modal-jumbo-mantenedor ></modal-jumbo-mantenedor>
            <modal-confirmacion @confirmar="enviar_jumbo($event)"></modal-confirmacion>
            <modal-ayuda></modal-ayuda>

            <tabla-paginada @cargar="cargar($event)" @editar="editar($event)"></tabla-paginada>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
// import Tabla from '@/components/shared/Tabla.vue';
// import Data_Table from '@/components/shared/Data_Table.vue';
// import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'
// import Modal_Jumbo_Configurable from '@/components/shared/Modal_Jumbo_Configurable.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import Modal_Jumbo_Mantenedor from '@/components/shared/Modal_Jumbo_Mantenedor.vue';
import Modal_Confirmacion from '@/components/shared/Modal_Confirmacion.vue';
import TablaPaginada from '@/components/shared/TablaPaginada.vue';

export default {
    data:()=>({
        query:'',
        lista:[],
        lotes:[],
        proviene_de:[],
        procesos:[],
        inputs:[
            {tipo:'autocomplete',valor:'',label:'Seleccione Lote',key:'lotes_id',opciones:[],texto:'nombre_lote',seleccion:'id'},
            {tipo:'autocomplete',valor:'',label:'Tipo MMPP Lote',key:'tipo_mps_id',opciones:[],texto:'tipo_materia_prima',seleccion:'id'},
            {tipo:'autocomplete',valor:'',label:'Proceso',key:'tipo_mps',opciones:[],texto:'tipo_materia_prima',seleccion:'id'},
            {tipo:'numero',valor:'',label:'Maxisaco N°*',key:'nro_jumbo'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:'',
            motivos_repaso:[]
        },
        columnas:[
            {nombre:'Lote',tipo: 'texto',path: 'nombre_lote',key:'nombre_lote',searchable:true,busqueda:''},
            {nombre:'Tipo MMPP Lote',align: 'center',tipo: 'autocomplete',opciones:[],path: 'tipo_materia_prima',key:'l_tipo_mps_id',searchable:true,busqueda:'',valor_opcion:'id',texto_opcion:'tipo_materia_prima'},
            {nombre:'Proceso',align: 'center',tipo: 'autocomplete',opciones:[],path: 'proceso_texto',key:'proceso_id',searchable:true,busqueda:'',valor_opcion:'id',texto_opcion:'tipo_materia_prima'},
            {nombre:'Maxisaco N°',align:'center',tipo: 'numero',path: 'nro_jumbo',key:'nro_jumbo',searchable:true,busqueda:''},
            {nombre:'Fecha Maxi',align:'center',tipo: 'texto',path: 'fecha',key:'fecha',searchable:false,busqueda:''},
            {nombre:'Peso (kg)',align:'center',tipo: 'numero',path: 'peso',key:'peso',searchable:false,busqueda:''},
            {nombre:'Proveniente de',align: 'center',tipo: 'texto',path: 'viene_del_jumbo',searchable:false,busqueda:''},
            {nombre:'Editar', key:'editar',tipo:'evento',color:'#1565C0',icono:'create',evento:'editar',searchable:false},
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    beforeDestroy() {
        Event.$off('actualizar_tabla');
    },
    mounted() {
        this.cargarLotes();
        this.cargarMotivosRepaso();
        this.cargarProcesos(),
        Event.$on('actualizar_tabla',()=>{
            //this.cargarDatos();
            this.cargar(this.query);
        });
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Maxisacos`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se muestra el listado de Maxisacos. Las columnas que se muestran son:`},
                        {   tipo:`label`,   texto:`- Número del lote, Tipo MMPP Lote, Proceso (puede ser diferente a la del lote cuando es un barrido), Nro del maxisaco, Fecha de elaboración del maxisaco, Peso del maxisaco y Proveniente de (cuando es producto del repaso de otro maxisaco)`},
                        {   tipo:`label`,   texto:`- Editar : Al hacer click en el botón de editar de cada fila, se abre una pantallita para poder modificar el peso y proceso del maxisaco `},
                        {   tipo:`imgtexto`,  url:`help-jumbos.png`, ratio:'4.1', cols:'2',  texto:`Bajo la fila de títulos tenemos la opción de filtrar información, o realizar búsquedas por lote, tipo de materia prima, proceso o número de maxisaco.`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarLotes(){
            //this.mostrarLoading('Cargando Lotes...');
            this.mostrarLoading({titulo:'Cargando Lotes...',color:'green'})

            let url = `${this.base_url}lotes`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('Tipos de Lote',response);
                this.lotes = response.data.data;
                this.inputs[0].opciones = this.lotes;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
        },

        async cargarMotivosRepaso(){
            let url = `${this.base_url}repaso_jumbos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('Motivos de Repaso',response);
                this.configuracion_modal.motivos_repaso = response.data.data;
                //this.cargarDatos();
                this.cargar('?page=1');
            }).catch((error)=>{
                console.log(error);
                
            })
            this.ocultarLoading();
        },

        async cargar(query){
            this.query = query;
            await this.axios.get(`${this.base_url}jumbos${query}`,this.headers).then((res)=>{
                this.lista = res.data.data.data;
                console.log("jumbitos", this.lista);
                this.actualizarTablaPaginada({columnas:this.columnas,lista:this.lista,total_paginas:res.data.data.last_page});
            }).catch((e)=>{
                console.log(e);
            })
        },

        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}jumbos`;
            await this.axios.get(url,this.headers).then(async (response)=>{
                console.log('respuesta',response.data);
                this.lista = response.data.data.data;
                await this.lista.forEach(jumbo => {
                    this.proviene_de.push({id:jumbo.id,texto:`(Lote ${jumbo.lote.nombre_lote}) N°${jumbo.nro_jumbo}`})
                });
                this.inputs[0].opciones = this.proviene_de;
                //Event.$emit('actualizar_lista',this.lista);
                //Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones);
                //Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                //this.$emit('setear_tabla',this.cabeceras_paginada,this.lista);
                this.actualizarTablaPaginada({columnas:this.columnas,lista:this.lista,total_paginas:response.data.data.last_page});
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
        },
        async cargarProcesos(){
            let url = `${this.base_url}tipo_mp/traza`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.procesos = res.data.data;
                this.columnas[1].opciones = this.procesos;
                this.columnas[2].opciones = this.procesos;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        crear(){
            console.log('crear');
            // this.configuracion_modal.titulo_modal = 'Crear Maxisaco';
            // this.configuracion_modal.boton_submit = 'Crear';
            // this.configuracion_modal.ruta = 'jumbos';
            // this.configuracion_modal.tipo_peticion = 'POST';
            // Event.$emit('abrir',this.inputs,this.configuracion_modal);
            let configuracion = {
                titulo_modal:'Crear Maxisaco',
                titulo_boton:'Crear',
                accion:'crear'
                // tipo_peticion:'POST',
                // url_peticion:`${this.base_url}jumbos`
            }
            Event.$emit('abrir_modal_jumbo',null,configuracion);

        },
        async editar($event){
            console.log('editando',$event);
            this.configuracion_modal.titulo_modal = 'Editar Maxisaco';
            this.configuracion_modal.titulo_boton = 'Actualizar';
            this.configuracion_modal.accion = 'editar';

            // let configuracion = {
            //     titulo_modal:'Editar Jumbo',
            //     titulo_boton:'Actualizar',
            //     accion:'editar',
            //     // tipo_peticion:'PUT',
            //     // url_peticion:`${this.base_url}jumbos/${$event.id}`
            // };
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            // this.inputs.forEach(input => {
            //     //recorrido del objeto a editar
            //     Object.keys($event).forEach(key => {
            //         let valor = $event[key];
            //         if(input.key == key){
            //             input.valor = valor;
            //         }
            //     });
            // });
            
            // let lote = await this.$buscarObjeto($event['lotes_id'],this.lotes);
            // this.inputs[0].valor = lote;
            // let proviene_de = await this.$buscarObjeto($event['viene_del_jumbo'],this.proviene_de);
            // this.inputs[2].valor = proviene_de;
            // this.configuracion_modal.titulo_modal = 'Editar Jumbo';
            // this.configuracion_modal.boton_submit = 'Actualizar';
            // this.configuracion_modal.ruta = `jumbos/${$event.id}`;
            // this.configuracion_modal.tipo_peticion = 'PUT';
            Event.$emit('abrir_modal_jumbo',$event.item,this.configuracion_modal);
            // console.log('inputs',this.inputs);
        },

        enviar_a_reproceso($event){
            let configuracion = {
                titulo:`Enviar Maxisaco a Reproceso`,
                mensaje:`¿ Está Seguro de Enviar a Reproceso el Maxisaco N° ${$event.nro_jumbo} del Lote N° ${$event.lote.nombre_lote}?`,
                border:'top',
                tipo:'warning'
            }
            Event.$emit('abrir_modal_confirmacion',configuracion,$event);
        },

        async enviar_jumbo($event){
            //this.mostrarLoading('Enviando Maxisaco a Reproceso...');
            this.mostrarLoading({titulo:'Enviando Maxisaco a Reproceso...',color:'green'})

            let url = `${this.base_url}jumbo/${$event.id}/reproceso`;
            let body = {
                repaso_jumbos_id:1,
                fecha_repaso: this.moment().format('YYYY-MM-DD HH:mm'),
            };
            await this.axios.put(url,body,this.headers).then((response)=>{
                this.cargarDatos();
                this.ocultarLoading();
                Event.$emit('cerrar_modal_confirmacion');
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            }); 
        },

        async restablecer_jumbo($event){
            //this.mostrarLoading('Restableciendo Maxisaco...');
            this.mostrarLoading({titulo:'Restableciendo Maxisaco...',color:'green'})

            let url = `${this.base_url}jumbo/${$event.id}/reproceso`;
            let body = {
                rechazo_jumbos_id:0
            };
            await this.axios.put(url,body,this.headers).then((response)=>{
                this.cargarDatos();
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        test(){

        },
        ...mapMutations(['mostrarLoading','ocultarLoading','actualizarTablaPaginada'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        //Tabla,
        // 'modal-jumbo-configurable':Modal_Jumbo_Configurable,
        'modal-jumbo-mantenedor':Modal_Jumbo_Mantenedor,
        //'data-table':Data_Table,
        'modal-confirmacion':Modal_Confirmacion,
        'tabla-paginada':TablaPaginada,
        'modal-ayuda':ModalAyudas
    }
}
</script>
<style scoped>
    .container{width:98%; max-width: 98%!important;}
</style>